/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Evolink_Base_UrlInputs */

const en_admin_settings_fields_evolink_base_url = /** @type {(inputs: Admin_Settings_Fields_Evolink_Base_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base URL`)
};

/**
* | output |
* | --- |
* | "Base URL" |
*
* @param {Admin_Settings_Fields_Evolink_Base_UrlInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_evolink_base_url = /** @type {((inputs?: Admin_Settings_Fields_Evolink_Base_UrlInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Evolink_Base_UrlInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_evolink_base_url(inputs)
});
export { admin_settings_fields_evolink_base_url as "admin.settings.fields.evolink_base_url" }